import type { MaybeRefOrGetter } from 'vue';
import type { FieldTypeTemplate } from '#layers/data-model/types/field-types';
import { computed, toValue } from 'vue';
import { useFieldTypeTemplates } from '#layers/data-model/composables/use-field-type-templates';

interface FieldWithMeta {
	meta?: {
		typeTemplateId?: string | null;
		typeOptions?: Record<string, unknown> | null;
	};
}

export function useFieldTypeTemplate(
	field: MaybeRefOrGetter<FieldWithMeta | null>,
) {
	const templates = useFieldTypeTemplates();

	const template = computed<FieldTypeTemplate | null>(() => {
		const f = toValue(field);
		const id = f?.meta?.typeTemplateId;
		if (!id || !(id in templates.value)) return null;
		return templates.value[id]!;
	});

	const typeOptions = computed(() => toValue(field)?.meta?.typeOptions ?? {});

	return { template, typeOptions };
}
